<!-- <p>dashboard-webhooks works!</p> -->
<div class="main-div" #main>
    <div class="panel-title">
        <span>{{panelData ? panelData.title : "Events"}}</span>
        <mat-icon *ngIf="creating && panelData" [matMenuTriggerFor]="titleMenu"
            [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="title alignRow">
        <span class="title-text" *ngIf="offlineWebhooks.length == 0">All Webhooks Online</span>
        <span class="title-text" *ngIf="offlineWebhooks.length > 0">{{offlineWebhooks.length}}
            Webhook{{offlineWebhooks.length != 1 ? 's' :
            ''}} Offline</span>
        <div class="title-checkbox alignRow">
            <span>Show Disabled</span>
            <mat-checkbox color="primary" [checked]="showDisabled" (change)="toggleShowDisabled($event)"></mat-checkbox>
        </div>
    </div>
    <div *ngIf="webhooks && webhooks.length > 0" class="webhooks-container">
        <ejs-listbox class="listbox" [dataSource]='filteredWebhooks' [fields]="whFields">
            <ng-template #itemTemplate let-data>
                <div class="webhook ejs-listbox-item alignRow"
                    [ngStyle]="{'border-color': data.Offline ? 'salmon' : 'lightgreen'}">
                    <div class="webhook-time">
                        <span>{{data.Description}}</span>
                        <span style="margin: auto;">{{convertEpoch(data.LastValueReceived)}}</span>
                    </div>
                    <mat-icon [ngStyle]="{'color': data.Offline ? 'salmon' : 'lightgreen'}">webhook</mat-icon>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</div>